module.exports = __webpack_public_path__ + "img/not touch.08978075.svg";